import { Controller } from 'react-hook-form';
import {
  Select,
  InputText,
  DateInput,
  Textarea,
  PickerPosition,
} from '@ui/src';
import { getAgreementTypeName } from '../../../hoc/settings/helpers/format-agreements-list';
import {
  AgreementType,
  AgreementClientType,
} from '../../../hoc/settings/types';
import { AgreementFormTypes } from './types';

import cn from './form.module.css';

const AgreementForm = ({
  control,
  errors,
  agreementId,
}: AgreementFormTypes) => (
  <div className={cn.agreementForm}>
    <div className={cn.agreementFormInputWrapper}>
      <Controller
        control={control}
        name="type"
        defaultValue=""
        render={({ field: { onChange, value, name } }) => (
          <Select
            list={[
              {
                name: getAgreementTypeName(AgreementType.PRIVACY_NOTICE),
                value: AgreementType.PRIVACY_NOTICE,
              },
              {
                name: getAgreementTypeName(AgreementType.GENERAL_T_AND_CS),
                value: AgreementType.GENERAL_T_AND_CS,
              },
              {
                name: getAgreementTypeName(AgreementType.ANNEX_1),
                value: AgreementType.ANNEX_1,
              },
              {
                name: getAgreementTypeName(AgreementType.ANNEX_2),
                value: AgreementType.ANNEX_2,
              },
              {
                name: getAgreementTypeName(AgreementType.ANNEX_3),
                value: AgreementType.ANNEX_3,
              },
              {
                name: getAgreementTypeName(AgreementType.ANNEX_4),
                value: AgreementType.ANNEX_4,
              },
              {
                name: getAgreementTypeName(AgreementType.ANNEX_5),
                value: AgreementType.ANNEX_5,
              },
              {
                name: getAgreementTypeName(AgreementType.ANNEX_6),
                value: AgreementType.ANNEX_6,
              },
              {
                name: getAgreementTypeName(AgreementType.ANNEX_7),
                value: AgreementType.ANNEX_7,
              },
              {
                name: getAgreementTypeName(AgreementType.ANNEX_8),
                value: AgreementType.ANNEX_8,
              },
            ]}
            placeholder="Choose document type"
            name={name}
            value={value}
            onChange={onChange}
            title="Document type"
            disabled={Boolean(agreementId)}
            tabIndex={agreementId ? -1 : 0}
            selectWrapperClassName={`${cn.agreementFormSelect} ${
              errors?.type?.message ? cn.agreementFormSelectError : ''
            } ${agreementId ? cn.disabledSelect : ''}`}
          />
        )}
      />
      {errors?.type?.message && (
        <div className={cn.error}>{errors?.type?.message}</div>
      )}
    </div>
    <div className={cn.agreementFormInputWrapper}>
      <Controller
        control={control}
        name="client"
        defaultValue=""
        render={({ field: { onChange, value, name } }) => (
          <Select
            list={[
              {
                name: 'Individual',
                value: AgreementClientType.INDIVIDUAL,
              },
              {
                name: 'Corporate',
                value: AgreementClientType.CORPORATE,
              },
              {
                name: 'Company Official',
                value: AgreementClientType.COMPANY_OFFICIAL,
              },
            ]}
            placeholder="Choose customer type"
            name={name}
            value={value}
            onChange={onChange}
            disabled={Boolean(agreementId)}
            tabIndex={agreementId ? -1 : 0}
            title="Customer type"
            selectWrapperClassName={`${cn.agreementFormSelect} ${
              errors?.client?.message ? cn.agreementFormSelectError : ''
            } ${agreementId ? cn.disabledSelect : ''}`}
          />
        )}
      />
      {errors?.client?.message && (
        <div className={cn.error}>{errors?.client?.message}</div>
      )}
    </div>
    <div className={cn.agreementFormInputWrapper}>
      <Controller
        control={control}
        defaultValue=""
        name="startAt"
        render={({ field: { onChange, value } }) => (
          <DateInput
            value={value}
            onChange={(date) => onChange(date.toISOString())}
            placeholder="Select date applied"
            title="Date applied"
            error={errors?.startAt?.message}
            disabled={Boolean(agreementId)}
            tabIndex={agreementId ? -1 : 0}
            pickerPisition={PickerPosition.RIGHT}
            className={`${cn.dateAppliedPicker} ${
              agreementId ? cn.disabledDatePicker : ''
            } ${errors?.startAt?.message ? cn.dateInputError : ''}`}
            withoutCustomSelector
            fullWidth
          />
        )}
      />
    </div>
    <div className={cn.agreementFormInputWrapper}>
      <Controller
        control={control}
        name="version"
        render={({ field: { onChange, value, name } }) => (
          <InputText
            name={name}
            value={value}
            placeholder="Enter version number..."
            title="Document version"
            onChange={onChange}
            disabled={Boolean(agreementId)}
            tabIndex={agreementId ? -1 : 0}
            error={errors.version?.message}
          />
        )}
      />
    </div>
    <div className={cn.agreementFormInputWrapper}>
      <Controller
        control={control}
        defaultValue=""
        name="description"
        render={({ field: { onChange, value, name } }) => (
          <Textarea
            name={name}
            value={value}
            placeholder="Describe the changes in this version..."
            title="Changes description"
            onChange={onChange}
            disabled={Boolean(agreementId)}
            tabIndex={agreementId ? -1 : 0}
            error={errors.description?.message}
          />
        )}
      />
      <Controller
        control={control}
        defaultValue=""
        name="uploadId"
        render={({ field: { value, name } }) => (
          <input type="hidden" name={name} value={value} tabIndex={-1} />
        )}
      />
    </div>
  </div>
);

export default AgreementForm;
